export default __webpack_public_path__ + "static/media/scenarios.2a13a7d6.txt";